<template>
    <div class="md:px-[40px] lg:px-[60px] py-6 overflow-hidden" style="border-top: 1px solid #e1e1e1; background-color: #fafafa; position: relative; z-index: 2;">
        <b-row class="px-0">
            <b-col cols="12" lg="4" class="footer-logo">
                <div class="flex" style="align-items: center;">
                    <img src="@/assets/img/logo.png" alt="Logo">
                    <h6 class="text-6xl mb-0 font-serif font-extrabold h-fit" style="color: #7D8600;">HUET</h6>
                </div>
                <h1 class="mb-0">Khoa Kỹ Thuật & Công Nghệ</h1>
                <h1>Đại học Huế</h1>
            </b-col>
            <b-col cols="12" lg="8" class="mt-2 mt-lg-0">
                <b-row>
                    <b-col cols="12" md="4" class="my-3 my-md-0">
                        <h2>Liên lạc</h2>
                        <div class="footer-content mx-auto">
                            <div v-for="(item, index) in config.position" :key="'position'+index" class="footer-text">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" /><path stroke-linecap="round" stroke-linejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" /></svg>
                                <p class="text-left">{{ item.address }}</p>
                            </div>
                            <div v-for="(item, index) in config.phone" :key="'phone'+index" class="footer-text">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M2.25 6.75c0 8.284 6.716 15 15 15h2.25a2.25 2.25 0 002.25-2.25v-1.372c0-.516-.351-.966-.852-1.091l-4.423-1.106c-.44-.11-.902.055-1.173.417l-.97 1.293c-.282.376-.769.542-1.21.38a12.035 12.035 0 01-7.143-7.143c-.162-.441.004-.928.38-1.21l1.293-.97c.363-.271.527-.734.417-1.173L6.963 3.102a1.125 1.125 0 00-1.091-.852H4.5A2.25 2.25 0 002.25 4.5v2.25z" /></svg>
                                <p class="text-left">{{ item.value }}</p>
                            </div>
                            <div class="footer-text">
                                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor"><path stroke-linecap="round" stroke-linejoin="round" d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75" /></svg>
                                <p class="text-left">{{ config.email }}</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4" class="my-3 my-md-0">
                        <h2>Đào tạo đại học</h2>
                        <div class="footer-content mx-auto">
                            <div @click="redirectToDetail(course._id)" 
                            class="footer-text cursor-pointer hover:text-prime-color" 
                            v-for="course in uniCourses" :key="course._id">
                                <p class="text-center">{{ course.name }}</p>
                            </div>
                        </div>
                    </b-col>
                    <b-col cols="12" md="4" class="my-3 my-md-0">
                        <h2>Đào tạo sau đại học</h2>
                        <div class="footer-content mx-auto">
                            <div @click="redirectToDetail(course._id)" 
                            class="footer-text cursor-pointer hover:text-prime-color" 
                            v-for="course in afterUniCourses" :key="course._id">
                                <p class="text-center">{{ course.name }}</p>
                            </div>
                        </div>
                    </b-col>
                </b-row>
            </b-col>
            
            <b-col cols="12">
                <div class="mx-auto my-3 w-full h-[1px] bg-gray-300"></div>
            </b-col>
            <b-col cols="12" class="footer-credit">
                <div class="d-flex justify-content-center" style="gap: 10px;">
                    <a :href="config.facebook"><i class='bx bx-md bxl-facebook-circle'></i></a>
                    <a :href="config.youtube"><i class='bx bx-md bxl-youtube' ></i></a>
                    <a :href="'mailto:' + config.email"><i class='bx bx-md bxs-envelope' ></i></a>
                </div>
                <h3 class="text-center !text-base">{{ config.credit }}. All Rights Reserved. <br class="d-md-none">Phiên bản {{ version }}.</h3>
            </b-col>
        </b-row>
    </div>
</template>
    
<script>
import { mapActions } from "vuex";
export default {
    props: {
        config: Object
    },
    data() {
        return {
            loading: true,
            uniCourses: [],
            afterUniCourses: [],
            version: ''
        }
    },
    methods: {
        ...mapActions('course', ['GetCourseList']),
        async getEntry(){
            let response = await this.GetCourseList();
            response.data.forEach(course => {
                if (course.type == 'Hệ đại học') {
                    this.uniCourses.push(course)
                } else {
                    this.afterUniCourses.push(course)
                }
            });
            this.loading = false
        },
        redirectToDetail(id) {
            this.$router.push({path: '/training/detail/' + id})
        },
    },
    created() {
        this.getEntry()
        this.version = process.env.VUE_APP_VERSION
    },
};
</script>
    
<style lang="scss" scoped>
h1 {
    font-size: 22px;
    font-weight: 700;
    color: var(--orange400);
}
h2 {
    font-size: 20px;
    font-weight: 700;
    text-align: center;
    color: var(--orange300);
}
h3 {
    font-size: 14px;
    font-weight: 400;
}
.footer-logo {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    img {
        width: 80px;
    }
}
.footer-content {
    display: flex;
    flex-direction: column;
    gap: 8px;
    width: fit-content;
}
.footer-text {
    display: flex;
    gap: 4px;
    svg {
        width: 24px;
    }
    p {
        width: 100%;
        margin-bottom: 0;
        text-align: center;
    }
}
.footer-credit {
    display: flex;
    flex-direction: column;
    justify-content: center;
}
@media screen and (min-width : 576px) {
    h1 {
        font-size: 22px;
        font-weight: 700;
    }
}

@media screen and (min-width: 768px) {
    .footer-credit {
    flex-direction: row;
    justify-content: space-between;
    div {
        order: 2;
    }
}
}

@media screen and (min-width: 992px) {
    
}

</style>
    